import gql from 'graphql-tag';
import { lightUserFragment } from './light-user.fragment';

export const groupFragment = gql`
  fragment groupFragment on Group {
    ID
    name
    membersCount
    photoURL
    description
    openMembership

    iamMember

    author {
      ...lightUserFragment
    }

    admins {
      ...lightUserFragment
    }
  }
  ${lightUserFragment}
`;
